// extracted by mini-css-extract-plugin
module.exports = {"title":"header-group-title_5xKxr","subtitle":"header-group-subtitle_6siXA","hr":"header-group-hr_CYUD7","icon":"header-group-icon_1Xbsy","root":"header-group-root_2W_zy"};